import * as Yup from "yup";
import { validation } from "@/constants/validation.translation";

/**
 * Validation class for SMS Template form
 * Contains validation schema for all SMS template fields
 */
class SmsTemplateValidationClass {
  
  /**
   * SMS Template validation schema
   * @param {function} t - Translation function
   * @returns {Yup.ObjectSchema} Validation schema for SMS template
   */
  static smsTemplateValidation(t = (key) => key) {
    const { smsTemplate: smsTemplateValidation } = validation;
    
    return Yup.object().shape({
      slug: Yup.string()
        .required(t(smsTemplateValidation?.slug_required || "Slug is required"))
        .matches(/^[a-z0-9_-]+$/, t(smsTemplateValidation?.slug_invalid || "Slug must contain only lowercase letters, numbers, underscores, and hyphens"))
        .min(3, t(smsTemplateValidation?.slug_min_length || "Slug must be at least 3 characters"))
        .max(100, t(smsTemplateValidation?.slug_max_length || "Slug must not exceed 100 characters")),
      parameter: Yup.string().nullable(),
      sms_templates: Yup.array()
        .of(
          Yup.object().shape({
            language_id: Yup.number()
              .required(t(smsTemplateValidation?.language_required || "Language is required"))
              .positive(t(smsTemplateValidation?.language_invalid || "Language must be a positive number")),
            title: Yup.string()
              .required(t(smsTemplateValidation?.title_required || "Title is required"))
              .min(2, t(smsTemplateValidation?.title_min_length || "Title must be at least 2 characters"))
              .max(255, t(smsTemplateValidation?.title_max_length || "Title must not exceed 255 characters")),
            content: Yup.string()
              .required(t(smsTemplateValidation?.content_required || "Content is required"))
              .min(10, t(smsTemplateValidation?.content_min_length || "Content must be at least 10 characters")),
            uuid: Yup.string().nullable(),
          })
        )
        .min(1, t(smsTemplateValidation?.at_least_one_template || "At least one template is required"))
        .required(t(smsTemplateValidation?.templates_required || "Templates are required")),
    });
  }
}

export default SmsTemplateValidationClass;
